import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// World map GeoJSON URL
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// List of all countries with ISO 3166-1 numeric codes (used by world-atlas)
const ALL_COUNTRIES = [
    { code: "004", name: "Afghanistan" },
    { code: "008", name: "Albania" },
    { code: "012", name: "Algeria" },
    { code: "020", name: "Andorra" },
    { code: "024", name: "Angola" },
    { code: "028", name: "Antigua and Barbuda" },
    { code: "032", name: "Argentina" },
    { code: "051", name: "Armenia" },
    { code: "036", name: "Australia" },
    { code: "040", name: "Austria" },
    { code: "031", name: "Azerbaijan" },
    { code: "044", name: "Bahamas" },
    { code: "048", name: "Bahrain" },
    { code: "050", name: "Bangladesh" },
    { code: "052", name: "Barbados" },
    { code: "112", name: "Belarus" },
    { code: "056", name: "Belgium" },
    { code: "084", name: "Belize" },
    { code: "204", name: "Benin" },
    { code: "064", name: "Bhutan" },
    { code: "068", name: "Bolivia" },
    { code: "070", name: "Bosnia and Herzegovina" },
    { code: "072", name: "Botswana" },
    { code: "076", name: "Brazil" },
    { code: "096", name: "Brunei" },
    { code: "100", name: "Bulgaria" },
    { code: "854", name: "Burkina Faso" },
    { code: "108", name: "Burundi" },
    { code: "116", name: "Cambodia" },
    { code: "120", name: "Cameroon" },
    { code: "124", name: "Canada" },
    { code: "132", name: "Cape Verde" },
    { code: "140", name: "Central African Republic" },
    { code: "148", name: "Chad" },
    { code: "152", name: "Chile" },
    { code: "156", name: "China" },
    { code: "170", name: "Colombia" },
    { code: "174", name: "Comoros" },
    { code: "178", name: "Congo" },
    { code: "180", name: "DR Congo" },
    { code: "188", name: "Costa Rica" },
    { code: "384", name: "Côte d'Ivoire" },
    { code: "191", name: "Croatia" },
    { code: "192", name: "Cuba" },
    { code: "196", name: "Cyprus" },
    { code: "203", name: "Czech Republic" },
    { code: "208", name: "Denmark" },
    { code: "262", name: "Djibouti" },
    { code: "212", name: "Dominica" },
    { code: "214", name: "Dominican Republic" },
    { code: "218", name: "Ecuador" },
    { code: "818", name: "Egypt" },
    { code: "222", name: "El Salvador" },
    { code: "226", name: "Equatorial Guinea" },
    { code: "232", name: "Eritrea" },
    { code: "233", name: "Estonia" },
    { code: "748", name: "Eswatini" },
    { code: "231", name: "Ethiopia" },
    { code: "242", name: "Fiji" },
    { code: "246", name: "Finland" },
    { code: "250", name: "France" },
    { code: "266", name: "Gabon" },
    { code: "270", name: "Gambia" },
    { code: "268", name: "Georgia" },
    { code: "276", name: "Germany" },
    { code: "288", name: "Ghana" },
    { code: "300", name: "Greece" },
    { code: "308", name: "Grenada" },
    { code: "320", name: "Guatemala" },
    { code: "324", name: "Guinea" },
    { code: "624", name: "Guinea-Bissau" },
    { code: "328", name: "Guyana" },
    { code: "332", name: "Haiti" },
    { code: "340", name: "Honduras" },
    { code: "348", name: "Hungary" },
    { code: "352", name: "Iceland" },
    { code: "356", name: "India" },
    { code: "360", name: "Indonesia" },
    { code: "364", name: "Iran" },
    { code: "368", name: "Iraq" },
    { code: "372", name: "Ireland" },
    { code: "376", name: "Israel" },
    { code: "380", name: "Italy" },
    { code: "388", name: "Jamaica" },
    { code: "392", name: "Japan" },
    { code: "400", name: "Jordan" },
    { code: "398", name: "Kazakhstan" },
    { code: "404", name: "Kenya" },
    { code: "296", name: "Kiribati" },
    { code: "408", name: "North Korea" },
    { code: "410", name: "South Korea" },
    { code: "414", name: "Kuwait" },
    { code: "417", name: "Kyrgyzstan" },
    { code: "418", name: "Laos" },
    { code: "428", name: "Latvia" },
    { code: "422", name: "Lebanon" },
    { code: "426", name: "Lesotho" },
    { code: "430", name: "Liberia" },
    { code: "434", name: "Libya" },
    { code: "438", name: "Liechtenstein" },
    { code: "440", name: "Lithuania" },
    { code: "442", name: "Luxembourg" },
    { code: "450", name: "Madagascar" },
    { code: "454", name: "Malawi" },
    { code: "458", name: "Malaysia" },
    { code: "462", name: "Maldives" },
    { code: "466", name: "Mali" },
    { code: "470", name: "Malta" },
    { code: "584", name: "Marshall Islands" },
    { code: "478", name: "Mauritania" },
    { code: "480", name: "Mauritius" },
    { code: "484", name: "Mexico" },
    { code: "583", name: "Micronesia" },
    { code: "498", name: "Moldova" },
    { code: "492", name: "Monaco" },
    { code: "496", name: "Mongolia" },
    { code: "499", name: "Montenegro" },
    { code: "504", name: "Morocco" },
    { code: "508", name: "Mozambique" },
    { code: "104", name: "Myanmar" },
    { code: "516", name: "Namibia" },
    { code: "520", name: "Nauru" },
    { code: "524", name: "Nepal" },
    { code: "528", name: "Netherlands" },
    { code: "554", name: "New Zealand" },
    { code: "558", name: "Nicaragua" },
    { code: "562", name: "Niger" },
    { code: "566", name: "Nigeria" },
    { code: "807", name: "North Macedonia" },
    { code: "578", name: "Norway" },
    { code: "512", name: "Oman" },
    { code: "586", name: "Pakistan" },
    { code: "585", name: "Palau" },
    { code: "591", name: "Panama" },
    { code: "598", name: "Papua New Guinea" },
    { code: "600", name: "Paraguay" },
    { code: "604", name: "Peru" },
    { code: "608", name: "Philippines" },
    { code: "616", name: "Poland" },
    { code: "620", name: "Portugal" },
    { code: "634", name: "Qatar" },
    { code: "642", name: "Romania" },
    { code: "643", name: "Russia" },
    { code: "646", name: "Rwanda" },
    { code: "659", name: "Saint Kitts and Nevis" },
    { code: "662", name: "Saint Lucia" },
    { code: "670", name: "Saint Vincent and the Grenadines" },
    { code: "882", name: "Samoa" },
    { code: "674", name: "San Marino" },
    { code: "678", name: "São Tomé and Príncipe" },
    { code: "682", name: "Saudi Arabia" },
    { code: "686", name: "Senegal" },
    { code: "688", name: "Serbia" },
    { code: "690", name: "Seychelles" },
    { code: "694", name: "Sierra Leone" },
    { code: "702", name: "Singapore" },
    { code: "703", name: "Slovakia" },
    { code: "705", name: "Slovenia" },
    { code: "090", name: "Solomon Islands" },
    { code: "706", name: "Somalia" },
    { code: "710", name: "South Africa" },
    { code: "728", name: "South Sudan" },
    { code: "724", name: "Spain" },
    { code: "144", name: "Sri Lanka" },
    { code: "729", name: "Sudan" },
    { code: "740", name: "Suriname" },
    { code: "752", name: "Sweden" },
    { code: "756", name: "Switzerland" },
    { code: "760", name: "Syria" },
    { code: "158", name: "Taiwan" },
    { code: "762", name: "Tajikistan" },
    { code: "834", name: "Tanzania" },
    { code: "764", name: "Thailand" },
    { code: "626", name: "Timor-Leste" },
    { code: "768", name: "Togo" },
    { code: "776", name: "Tonga" },
    { code: "780", name: "Trinidad and Tobago" },
    { code: "788", name: "Tunisia" },
    { code: "792", name: "Turkey" },
    { code: "795", name: "Turkmenistan" },
    { code: "798", name: "Tuvalu" },
    { code: "800", name: "Uganda" },
    { code: "804", name: "Ukraine" },
    { code: "784", name: "United Arab Emirates" },
    { code: "826", name: "United Kingdom" },
    { code: "840", name: "United States" },
    { code: "858", name: "Uruguay" },
    { code: "860", name: "Uzbekistan" },
    { code: "548", name: "Vanuatu" },
    { code: "336", name: "Vatican City" },
    { code: "862", name: "Venezuela" },
    { code: "704", name: "Vietnam" },
    { code: "887", name: "Yemen" },
    { code: "894", name: "Zambia" },
    { code: "716", name: "Zimbabwe" }
].sort((a, b) => a.name.localeCompare(b.name));

const ITEMS = ALL_COUNTRIES.map(c => ({ id: c.code, name: c.name }));

// Antarctica + small unselectable territories — rendered grey, non-clickable.
const NON_SELECTABLE_CODES = ['010', '304', '260', '238', '732'];

const WorldMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 89,
                center: [25, 35],
                rotate: [-10, 0, 0]
            }}
            width={720}
            height={460}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies.map((geo) => {
                        const countryCode = geo.id;
                        const isVisited = visited.includes(countryCode);
                        if (NON_SELECTABLE_CODES.includes(countryCode)) {
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        }

                        return (
                            <Geography
                                key={geo.rsmKey}
                                geography={geo}
                                onClick={() => toggle(countryCode)}
                                style={geographyStyles(isVisited, hexColor)}
                            />
                        );
                    })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="world"
            analyticsLocationType="world_country"
            trackingLabel="World Map"
            storageKey="world_map"
            title="🌍 World Travel Map"
            subtitle="Click on countries you've visited, or use the checklist below!"
            items={ITEMS}
            noun="Countries"
            unitLabel="countries"
            share={{
                region: 'World',
                fileName: 'visited-countries-map.png',
                trackId: 'world'
            }}
            renderMap={renderMap}
        />
    );
};

export default WorldMapSection;
